import { DATA_ATTR_HEADING_FONT, DATA_ATTR_THEME } from './consts';
import { resolveHeadingFontByLocale } from './resolveHeadingFontByLocale';
import type { Direction, ThemeMode } from './types';

export const getDocumentAttributes = (params: {
  direction: Direction;
  locale: string;
  themeMode: ThemeMode | undefined;
}) => ({
  [DATA_ATTR_THEME]: params.themeMode ?? 'light',
  [DATA_ATTR_HEADING_FONT]: resolveHeadingFontByLocale(params.locale),
  dir: params.direction,
});
